/**
 * useLocale — minimal locale hook for Cascadia (board-game-client).
 *
 * Cloned from playground; UI is NOT shared (CLAUDE.md).
 * Returns a `t(key)` function resolving against the active locale.
 * Falls back to the key itself when missing.
 */

import { DEFAULT_LOCALE, type LocaleCode, locales } from "./index";

export interface UseLocaleReturn {
  readonly t: (key: string) => string;
  readonly locale: LocaleCode;
}

export function useLocale(
  locale: LocaleCode = DEFAULT_LOCALE,
): UseLocaleReturn {
  const map = locales[locale];

  const t = (key: string): string => map[key] ?? key;

  return { t, locale };
}
